// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioBox_radio__mk59O","box":"RadioBox_box__2SsJz"};